<template>
  <v-sheet dark class="fill-height" :class="{'bg-sheet': largeScreen || true}" color="primary">
  <v-card color="transparent" dark flat tile class="fill-height mx-auto" max-width="500">
    <onboarding type="login" v-if="!$route.query.redir && !isWeb"></onboarding>
    <v-overlay :value="loading"> 
      <v-progress-circular  @click="loading=false"
        indeterminate
        size="64"></v-progress-circular>
    </v-overlay>
    <v-sheet color="transparent" class="mx-auto fill-height">
      <center><eetplein street="eetplein" :city="title" class="large mb-15" style="margin-top:15vh"></eetplein></center>
    <v-sheet class="rounded-xl mx-2 pb-5" style="background:RGBA(0,0,0,0.5)">
    <v-window v-model="tabs" class="pa-5" v-if="!authenticated">
      <v-window-item>
       
      <v-row align="center" justify="center">
        <!--v-card-title
          class="text-h3 text-center font-weight-light"
          justify="center"
          style="word-break: keep-all"
          >Login</v-card-title
        -->
        <v-card-text align="center" class="text-h6 font-weight-light">
          
         <template v-if="validPhone">
            <v-card-title class="justify-center text-h4" @click="phone=null">{{phone}}</v-card-title>
            <span class="text-center" v-if="testmodus">Beginnen met testen?</span>
            <span class="text-center" v-else>Is dit nummer juist?</span>
         </template>
           <template v-else>
             <v-form>
               <!--v-text-field v-model="phone" autofocus placeholder="**********" class="text-h2 numberinput"></v-text-field-->
             <!--otp-input ref="otpInput" :length="10" :autofocus="true" class="mb-5" :dark="true"
              v-model="phone" color="primary" @finish="setThisPhone($event)"
              ></otp-input-->
             <v-otp-input hide-spin-buttons
              prepend-icon="mdi-cellphone"
              v-model="phone"
              name="login"
              :autofocus="platform!=='ios'"
              
              type="number" class="my-2 text-h4 mx-auto phone"
               :rules="[$config.rules.mobile]"
              @focus="hasFocus=true"
              @blur="hasFocus=false"
              max  length="10"
            ></v-otp-input>
           
          </v-form>
          <span v-html="message1" @click="clickModus"></span>
          </template>
          <v-subheader class="mt-5" style="line-height:1.5;">We vragen je telefoonnummer om je op de hoogte te houden van je bestellingen.</v-subheader>
        </v-card-text>
      </v-row>

    </v-window-item>
    <v-window-item>
      
      <v-row align="center" justify="center">
        <!--v-card-title
          class="text-h3 text-center font-weight-light"
          justify="center"
          style="word-break: keep-all"
          >SMS code</v-card-title
        -->
        <v-card-text align="center" class="text-h6 font-weight-light">
          <v-form> 
            <div class="d-flex pr-15 mx-auto" style="max-width:400px">
               <v-btn text @click="tabs=0" class="mt-3" v-if="tabs==1"><v-icon large>arrow_back_ios</v-icon> </v-btn>
               <!--v-text-field v-model="code" autofocus placeholder="****" class="numberinput"></v-text-field-->
             <!--otp-input ref="otpInput" :length="4" :autofocus="true" class="mb-5"  :dark="true"
               v-model="code" color="primary"
              ></otp-input-->
            <v-otp-input hide-spin-buttons
              v-model="code"
              :disabled="loading"
              type="number"
              :autofocus="platform!=='ios'"
              length="4"
              @finish="doLogin"
               @focus="hasFocus=true"
              @blur="hasFocus=false"
              style="width:300px" background-color="primary"
            ></v-otp-input>
            </div>
            <v-btn text v-if="code && code.length==4" @click="doLogin">Inloggen</v-btn>
            <!--v-text-field
              v-model.number="code"
              name="code"
              placeholder="SMS code"
              type="number"
              autofocus
              @input="doLogin"
               @focus="hasFocus=true"
              @blur="hasFocus=false"
              v-on:keydown.enter.prevent="doLogin"
              class="mb-5 text-h6 mx-5"
            ></v-text-field-->
            
          </v-form>
          <span v-text="message"></span>
          <v-subheader class="mt-5" style="line-height:1.5;">Om je gegevens veilig te houden controleren we je nummer met een sms-code.</v-subheader>
        </v-card-text>
      </v-row>
    </v-window-item>
    </v-window>
     <v-footer color="transparent" v-if="validPhone">
     
      <v-btn text @click="clickModus" v-if="tabs==0 && !validPhone"></v-btn>
       <v-btn id="btnPrev" text @click.stop="phone=null" v-if="validPhone && tabs==0" class="text-h6"> Nee</v-btn>
      <v-spacer></v-spacer>
      <v-btn id="btnNext" text @click.stop="checkPhone(phone,false)" v-if="validPhone && tabs==0" class="text-h6"> Ja <v-icon class="ml-2">chevron_right</v-icon></v-btn>
      <v-btn id="btnLogin" text @click.stop="doLogin(code)" v-else-if="validPhone && false"> Inloggen </v-btn>
    </v-footer>
    </v-sheet>
 <v-btn text @click="clickModus" v-if="tabs==0 && !validPhone"></v-btn>
    </v-sheet>
  
  </v-card>
  </v-sheet>
</template>
<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import Onboarding from '../components/Onboarding.vue'
import Eetplein from "@/components/Eetplein";
export default {
   components: {
    Onboarding, Eetplein
  },
  data: () => ({
    tabs:0,
    modusCount: 0,
    code: null,
    sent: false,
    hasFocus: false,
    loading: false,
    message1: 'Wat is je mobiele telefoonnummer?',
    message: "Vul de sms-code in om in te loggen",
    timer: null
  }),
  computed:{
 ...mapGetters([
        'getPhone','modus','authenticated', 'token'
      ]),
      phone:{
            get(){
                return this.getPhone
            },
            set(value){
                this.setPhone(value)
            }
        },
        title() {
        //if (this.hub) return this.hub.name
          return "lekker lokaal bestellen";
        },
        testmodus:{
            get(){
                return this.modus == 'test' ? true : false
            },
            set(value){
                this.setModus(value ? 'test': 'live')
            }
        },
        validPhone(){
          if (!this.phone || this.phone.length !== 10) return false
          return this.$config.rules.mobile(this.phone)==true ? true : false
        }
  },
  mounted(){
    if (this.testmodus) this.message1 = "<b class='yellow--text'>De testmodus is ingeschakeld. klik hier om te deactiveren</b>"
    this.$vuetify.goTo(document.body.scrollHeight)
  },
  watch:{
    testmodus(value, old){
      if (value) this.message1 = "<b>De testmodus is ingeschakeld. klik hier om te deactiveren</b>"
      if (old && !value) this.message1 = "Je bent weer in de live omgeving"
    },
    code(value){
      if(value && value.length==4) return this.doLogin(value)
    }
  },
  methods: {
    ...mapActions([
        'login','setModus'
      ]),
      ...mapMutations([
        'setPhone'
      ]),
    clickModus(){
      if (this.modusCount >2){
        return this.testmodus=!this.testmodus
      }
      this.modusCount +=1
    },
    setThisPhone(phone){
      this.phone = phone || this.phone
      if (!this.validPhone) return this.message1 = 'Vul een geldig 06 nummer in'
    },
    async checkPhone(phone, retry) {
      this.phone = phone || this.phone
      if (!this.validPhone) return this.message1 = 'Vul een geldig 06 nummer in'
      this.loading = true
      this.sent = true
      try{
        
      /*if (this.timer) clearTimeout(this.timer)
      this.timer = setTimeout(()=>{
         this.loading = false
          this.sent = false
          if (!retry) this.checkPhone(true)
      },4000)*/
      
        let response = await this.$http
          .post("/api/auth/signup", {
            phone: this.phone
          })
          this.loading = false
          if (response.data.error) return this.message1 = "Er is iets misgegaan bij het aanmelden, probeer het opnieuw." + response.data.error.message
          if (this.timer && response.data.status == "OK") clearTimeout(this.timer)
          if (response.data.status == "OK" &&  response.data.user) return this.next(response)
          if (response.data.status == "OK") this.tabs=1
          this.$vuetify.goTo(document.body.scrollHeight)
      }catch(e){
        this.message1 = "Er is iets misgegaan bij het aanmelden, probeer het opnieuw. " + e.message
      }
        this.loading = false
    },
    reset(message,full){
      if (message) this.message = message
      if (full) this.phone = null
      this.code = null
      this.loading = false
    },
    next(response){
      if (this.timer) clearTimeout(this.timer)
        response.data.user._verified = new Date()
        this.login(response.data)
        //if (localStorage.getItem('jwt') != null){
            this.$emit('loggedIn')
            this.loading = false
            if(this.$route.query.redir != null){
                return this.$router.push({'path' :this.$route.query.redir})
            }
            else{
               console.log('nav login')
                return this.$router.push({'name' : "dashboard" })
            }
    },
    async doLogin(code) {
      this.code = code
      if (this.code<1000 || this.loading || !this.phone.length == 10) return this.message = "Vul je 4 cijferige code in"
      this.loading = true
      this.message = "Verbinding maken met eetplein..."
      let to = setTimeout(()=>this.message = "De verbinding met eetplein is mislukt, probeer het nog een keer",5000)
      try{
        let response = await this.$http
        .post("/api/auth/login", {
          phone: this.phone,
          code: this.code
        })
        clearTimeout(to)
        if (response.status==401) {
          this.code = null
          return this.reset("Ongeldige code ingevoerd voor " + this.phone)
        }
        return this.next(response)       
          //}
        }catch(e){
            this.message = "Ongeldige code ingevoerd voor " + this.phone
            this.code = null
            this.loading = false
            clearTimeout(to)
            return 
        }
      
    },
  },
};
//axios.defaults.headers.common['Authorization'] = AUTH_TOKEN;
</script>
<style>
.bg-sheet{
  background: url(/banner/bg_login-min.jpg) no-repeat center center fixed; 
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
}
.v-text-field.numberinput{
  width:280px;
}
.v-text-field.numberinput input{
  letter-spacing: 10px;
}

</style>
